if (!customElements.get('virgo-gallery')) {
  customElements.define('virgo-gallery', class extends HTMLElement {
    connectedCallback() {
      if (this.abort) return;
      this.abort = new AbortController();
      const opts = {signal:this.abort.signal};
      this.track = this.querySelector('.virgo-gallery__slides');
      this.slides = [...this.querySelectorAll('.virgo-gallery__slide')];
      this.index = 0;
      this.addEventListener('click', e => {
        const thumbnail = e.target.closest('[data-index]');
        const arrow = e.target.closest('[data-step]');
        if (thumbnail) this.show(Number(thumbnail.dataset.index));
        if (arrow) this.show((this.index + Number(arrow.dataset.step) + this.slides.length) % this.slides.length);
      }, opts);
      this.track.addEventListener('keydown', e => {
        if (e.key === 'ArrowRight' || e.key === 'ArrowLeft') {
          e.preventDefault(); this.show((this.index + (e.key === 'ArrowRight' ? 1 : -1) + this.slides.length) % this.slides.length);
        }
      }, opts);
      this.track.addEventListener('scroll', () => {
        this.index = Math.round(this.track.scrollLeft / Math.max(1, this.track.clientWidth));
        this.querySelector('[data-counter]').textContent = `${this.index + 1} / ${this.slides.length}`;
        this.querySelectorAll('[data-index]').forEach(b => b.setAttribute('aria-pressed', String(Number(b.dataset.index) === this.index)));
      }, opts);
      this.closest('section').addEventListener('change', e => {
        if (e.target.closest('variant-selects')) {
          const selected = e.target.value.toLowerCase();
          if (selected === 'white' || selected === 'black') this.show(selected === 'white' ? 1 : 0);
        }
      }, opts);
      if (this.dataset.initialColor.toLowerCase() === 'white') requestAnimationFrame(() => this.show(1));
    }
    show(index) {this.track.scrollTo({left:index * this.track.clientWidth,behavior:'instant'});}
    // Preserve the theme's media API for variant updates, without replacing bundled images.
    setActiveMedia() {}
    disconnectedCallback() {this.abort?.abort();this.abort=null;}
  });
}
